var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("H1", { staticClass: "pageTitle" }, [_vm._v("EMAIL VERIFIED")]),
        _vm._v(" "),
        _c("div", { staticClass: "top40 is-size-5 has-text-white" }, [
          _vm._v(
            "\n            Thank you! Your email has been verified. Please login:\n            "
          ),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "button is-warning", on: { click: _vm.doLogin } },
            [_vm._v("LOG IN")]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ffa136c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ffa136c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Verified.vue
// module id = null
// module chunks = 